import React from "react";
import OrderUrigawa from './OrderUrigawa';
import OrderKaigawa from './OrderKaigawa';
import MobileOrderDetail from './MobileOrderDetail';
import './MobileOrderDetail.css';

import firebase from "../../firebase"

class Order extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 500;

    if (this.props.id === 'dashboard') {
      return null;
    }

    if (!this.props.org) {
      return (
        <>
          取引先を選択してください。
        </>
      )
    }

    if (isMobile) {
      return (
        <MobileOrderDetail 
          db={this.props.db} 
          storage={this.props.storage} 
          id={this.props.id} 
          user={this.props.user} 
          org={this.props.org} 
          userOrg={this.props.userOrg} 
          readOrder={(readCount) => this.props.readOrder(readCount)} 
          shippedOrder={(shippedCount) => this.props.shippedOrder(shippedCount)} 
          dateNow={this.props.dateNow}
          cProps={this.props.cProps || this.props}
        />
      );
    }

    let kaigawa = false;
    let urigawa = false;
    if ( (this.props.userOrg && this.props.userOrg.buyer && this.props.org && this.props.org.reseller)
    || (this.props.userOrg && this.props.userOrg.reseller && this.props.org && this.props.org.maker)
    ){
      kaigawa = true;
    }
    if ( (this.props.userOrg && this.props.userOrg.reseller && this.props.org && this.props.org.buyer)
    || (this.props.userOrg && this.props.userOrg.maker && this.props.org && this.props.org.reseller)
    ){
      urigawa = true;
    }

    return (
      <>
        { urigawa &&
        <OrderUrigawa db={this.props.db} storage={this.props.storage} id={this.props.id} user={this.props.user} org={this.props.org} userOrg={this.props.userOrg} readOrder={(readCount) => this.props.readOrder(readCount)} shippedOrder={(shippedCount) => this.props.shippedOrder(shippedCount)} dateNow={this.props.dateNow} />
        }
        { kaigawa &&
        <OrderKaigawa db={this.props.db} storage={this.props.storage} id={this.props.id} user={this.props.user} org={this.props.org} userOrg={this.props.userOrg} readOrder={(readCount) => this.props.readOrder(readCount)} shippedOrder={(shippedCount) => this.props.shippedOrder(shippedCount)} dateNow={this.props.dateNow} />
        }
      </>
    )
  }
}
export default Order;

